import React from 'react';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import PortfolioScoreCard from './PortfolioScoreCard';
import AlignmentBadge from './AlignmentBadge';
import InsightCard from './InsightCard';
import { usePortfolioInsights } from './hooks/usePortfolioInsights';

const PortfolioInsightsPanel: React.FC = () => {
  const { data, loading, error } = usePortfolioInsights();

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!data) return null;

  // Order: Risk → Optimization → Opportunity
  const order = ['RISK', 'OPTIMIZATION', 'OPPORTUNITY'];
  const sortedInsights = [...data.insights]
    .sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type))
    .slice(0, 3);

  return (
    <Box>
      <PortfolioScoreCard score={data.portfolioScore} />
      <AlignmentBadge alignment={data.alignment} />
      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          Insights prioritaires
        </Typography>
        {sortedInsights.map((insight, idx) => (
          <InsightCard key={idx} insight={insight} />
        ))}
      </Box>
    </Box>
  );
};

export default PortfolioInsightsPanel;
